import styled from 'styled-components';

const RelativeContainer = styled.div<React.CSSProperties>`
  position: relative;
`;

export default RelativeContainer;
